import styled from 'styled-components';
const MultipleInputPopoverBodyWrapper = styled.div.withConfig({
  displayName: "MultipleInputPopoverBodyWrapper",
  componentId: "sc-1b71ujx-0"
})(["max-height:50vh;overflow-y:auto;"]);
export default MultipleInputPopoverBodyWrapper;